export default __webpack_public_path__ + "static/assets/med_pill_square_out_L2_solid_x_01_f_mask.c3fd3cde.png";